export default __webpack_public_path__ + "static/media/calendar.a2f587f2.png";